import React from 'react';
import {useState} from 'react';
import ClipModalTimeInfo from './ClipModalTimeInfo';
import ClipModalUserInfo from './ClipModalUserInfo';
import ClipModalCancel from './ClipModalCancel';
import ClipModalShare from './ClipModalShare';
import ClipModal from './ClipModal';
import pfp from './pfp.png';
import { RiScissors2Fill } from "react-icons/ri"

function ClipButton(props) {

    const[openClipModal, setOpenClipModal] = useState(false);

    return (
      <div>
        <div
          className="w-24 rounded-xl h-10 bg-gradient-to-br from-zinc-600 to-zinc-800 flex items-center text-white justify-center px-2 cursor-pointer"
          onClick={() => {
            setOpenClipModal(true);
          }}
        >
          <div className="flex items-center justify-center w-full">
            <div className="text-zinc-300 cursor-pointer hover:text-white flex items-center">
              <RiScissors2Fill className="mr-2"/>
              Clip
            </div>
          </div>
        </div>
          {openClipModal && <ClipModal setOpenClipModal={setOpenClipModal} />}
        </div>
    );
}

export default ClipButton;
